// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hn-0";